<template>
  <div class="m-card-primary m-the-modal-content">
    <form
      autocomplete="off"
      name="the-modal-form"
      @submit.prevent="$modal.closeModal"
    >
      <header class="m-the-modal-header">
        <h5>{{ $t('mEditionBillingSalesDataModalActionDisabled.title') }}</h5>
        <AtomButtonTheModalCloseIcon/>
      </header>
      <section class="m-the-modal-section">
        <p>{{ $t('mEditionBillingSalesDataModalActionDisabled.messageAlert') }}</p>
      </section>
      <footer class="m-the-modal-footer">
        <AtomButtonPrimary :button-primary="buttonPrimary"/>
      </footer>
    </form>
  </div>
</template>

<script>
export default {
  name: 'MoleculeEditionBillingSalesDataModalActionDisabled',

  data () {
    return {
      buttonPrimary: {
        action: this.$t('mEditionBillingSalesDataModalActionDisabled.buttonPrimary'),
        class: 'a-button-billing-primary',
        sending: false,
        type: 'submit'
      }
    }
  }
}
</script>
